<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h2>{{$t('targetZen.subtitle')+$store.state.form.resultJson.userInfos.firstname+" "+$store.state.form.resultJson.userInfos.lastname}}</h2>
        <h1>{{$t('targetZen.title')}}</h1>
      </div>
    </div>
    <div v-for="i in Math.ceil((targetZenList.length)/nbColumn)" :key="i" class="row listOfButtons">
      <div v-for="(item, index) in targetZenList.slice((i-1)*nbColumn, (i-1)*nbColumn+nbColumn)"  :key="index" class="col">
        <a @click="addElementToList((i-1)*nbColumn+index)"><img :src="targetZenImgList[(i-1)*nbColumn+index]" alt="ImgZen" class="imgBig clickableItem" /><br/>
          <button :class="'btn btn-secondary targetButton ' + ((alreadyListed((i-1)*nbColumn+index) !== false) ? 'bg-color' : '')">{{item}}</button></a>
      </div>
    </div>
    <h2 class="titleSlider">{{$t('targetZen.titleSlider')}}</h2>
    <vue-slider v-if="isActivated === true" ref="sliderStressIntensity" class="sliderComponent" v-bind="options" v-model="stressIntensity"
                v-on:drag-start="$store.commit('form/SLIDER_DRAG_EVENT', true)" v-on:drag-end="$store.commit('form/SLIDER_DRAG_EVENT', false)">
      <template slot="tooltip" slot-scope="{ value }">
        <div class="diy-tooltip" style="color: #FFFFFF; position: relative; bottom:43px">
          {{ value }}
        </div>
      </template>
      <template slot="label" slot-scope="{ label, active }">
        <span :class="['custom-label', { active }]" v-if="label % 2 === 0 && label !== 0" style="position: relative; top:40px; color : #909090">
          {{ label }}
        </span>
      </template>
    </vue-slider>
    <div class="row"><div class="col"><p class="questionLabel">{{$t('targetZen.care.question')}}</p></div></div>
    <div class="row listOfButtons">
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((care == 'individually') ? 'bg-color' : '')" @click="care='individually'">{{$t('targetZen.care.individually')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((care == 'subGroup') ? 'bg-color' : '')" @click="care='subGroup'">{{$t('targetZen.care.subGroup')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((care == 'groupLesson') ? 'bg-color' : '')" @click="care='groupLesson'">{{$t('targetZen.care.groupLesson')}}</button>
      </div>
    </div>
    <div class="row">
      <div class="col overFooter">
        <button type="submit" :class="'btn btn-primary alignRight ' + ((returnTargetList.length > 0 && care !== '') ? 'bg-color' : '')" @click="saveData()">{{$t('general.next')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
export default {
  name: 'target-zen',
  components: {
    vueSlider
  },
  data () {
    return {
      nbColumn: 4,
      isActivated: true,
      backgroundColorRight: 'fb5048',
      backgroundColorLeft: '96C13C',
      backgroundColor: this.backgroundColorLeft,
      backgroundColorRed: '96',
      backgroundColorGreen: 'C1',
      backgroundColorBlue: '3C',
      stressIntensity: 0,
      care: '',
      returnTargetList: [],
      targetZenList: [
        this.$i18n.t('targetZen.stressManagement'),
        this.$i18n.t('targetZen.workScale'),
        this.$i18n.t('targetZen.improveZen'),
        this.$i18n.t('targetZen.muscleBuild')],
      targetZenVarList: [
        'stressManagement',
        'workScale',
        'improveZen',
        'muscleBuild'],
      targetZenImgList: [
        'https://sales.deciplus.pro/static/img/TargetZen/stressManagement.png',
        'https://sales.deciplus.pro/static/img/TargetZen/workScale.png',
        'https://sales.deciplus.pro/static/img/TargetZen/improveZen.png',
        'https://sales.deciplus.pro/static/img/TargetZen/muscleBuild.png'],
      options: {
        dotSize: 50,
        min: 0,
        max: 10,
        piecewiseLabel: true,
        tooltipDir: 'bottom',
        sliderStyle: [
          {
            'backgroundColor': '#96C13C'
          },
          {
            'backgroundColor': '#96C13C'
          }
        ],
        processStyle: {
          'backgroundImage': '' // Gradient de couleur du vert vers le rouge
        }
      }
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'TargetZen', isAuthorized: this.returnTargetList.length !== 0 && this.care !== '', data: this.dataTosave});
    this.backgroundColorRed = (Math.round(parseInt(this.backgroundColorRight[0] + this.backgroundColorRight[1], 16) - ((parseInt(this.backgroundColorRight[0] + this.backgroundColorRight[1], 16) - parseInt(this.backgroundColorLeft[0] + this.backgroundColorLeft[1], 16)) * (1 - (this.stressIntensity / this.options.max)))).toString(16));
    this.backgroundColorGreen = (Math.round(parseInt(this.backgroundColorRight[2] + this.backgroundColorRight[3], 16) - ((parseInt(this.backgroundColorRight[2] + this.backgroundColorRight[3], 16) - parseInt(this.backgroundColorLeft[2] + this.backgroundColorLeft[3], 16)) * (1 - (this.stressIntensity / this.options.max)))).toString(16));
    this.backgroundColorBlue = (Math.round(parseInt(this.backgroundColorRight[4] + this.backgroundColorRight[5], 16) - ((parseInt(this.backgroundColorRight[4] + this.backgroundColorRight[5], 16) - parseInt(this.backgroundColorLeft[4] + this.backgroundColorLeft[5], 16)) * (1 - (this.stressIntensity / this.options.max)))).toString(16));
    this.backgroundColor = this.backgroundColorRed + this.backgroundColorGreen + this.backgroundColorBlue;
    this.options.processStyle.backgroundImage = '-webkit-linear-gradient(left, #96C13C, #' + this.backgroundColor + ')';
    this.options.sliderStyle[0].backgroundColor = '#' + this.backgroundColor;
    this.options.sliderStyle[1].backgroundColor = '#' + this.backgroundColor;
  },
  deactivated: function () {
    this.isActivated = false;
  },
  activated: function () {
    this.isActivated = true;
  },
  methods: {
    saveData: function () {
      if (this.returnTargetList.length !== 0 && this.care !== '') {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
      }
    },
    alreadyListed: function (index) {
      for (var i = 0; i < this.returnTargetList.length; i++) {
        if (this.targetZenVarList[index] === this.returnTargetList[i]) {
          return i;
        }
      }
      return false;
    },
    addElementToList: function (index) {
      var indexAlreadyListed = this.alreadyListed(index);
      if (indexAlreadyListed === false) {
        this.returnTargetList.push(this.targetZenVarList[index]);
      } else {
        this.returnTargetList.splice(indexAlreadyListed, 1);
      }
    }
  },
  computed: {
    dataTosave: function () {
      return {
        targetZen: {
          targetZenList: [...this.returnTargetList],
          stressIntensity: this.stressIntensity,
          care: this.care
        }
      };
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/TargetZen.vue